import React, { useEffect } from 'react';
import { setProductGroup } from 'redux/services/donaldGrump/releasedProductsParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';
import { FancyInput } from '../Inputs';

export const CategoryFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setProductGroup(value || undefined));
  }, 500);

  // Clears state on unmount
  useEffect(() => {
    return (): void => {
      dispatch(setProductGroup(undefined));
    };
  }, [dispatch]);

  return <FancyInput placeholder="Category" onChange={handleChange} />;
};
